// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3zkQs","right":"Footer_right__2epJL","buttons":"Footer_buttons__1GcoH"};